import {withActions} from '../withActions'
import constants from './constants'
import * as _ from 'lodash'
export const name = 'ViewportAspect'

const {HANDLERS_NS, INTERSECTIONS, VIEWPORT_STATE, VIEWPORT_STATE_REQUESTS} = constants

export const defaultModel = {
    [HANDLERS_NS]: {},
    [INTERSECTIONS]: [],
    [VIEWPORT_STATE]: {},
    [VIEWPORT_STATE_REQUESTS]: {}
}

const privateObserver = new WeakMap()
const cleanup = new WeakMap()
export const functionLibrary = {
    register: withActions(({addViewportHandler}, id, handler) => addViewportHandler(id, handler)),
    unregister: withActions(({removeViewportHandler, setViewportState}, id) => {
        removeViewportHandler(id)
        setViewportState(id) // delete component's state from store
    }),
    checkComponentViewportState: withActions(({setViewportStateRequest}, id) => new Promise(resolve => setViewportStateRequest(id, resolve))),

    resolveViewportStateRequest: withActions(({setViewportStateRequest}, resolve, compRef, id, state) => {
        if (compRef && !state) {
            return
        }

        const {visible} = compRef ? state : {visible: false}
        resolve({in: visible})
        setViewportStateRequest(id)
    }),

    updateObservers: withActions(({setViewportIntersections}, {next, previous}, windowObject) => {
        if (!windowObject) {
            return
        }

        let observer = privateObserver.get(windowObject)
        if (!observer) {
            const options = {
                root: null, // document
                rootMargin: '0px',
                threshold: [0.15]
            }
        
            const handler = entries => {
                const intersections = entries.map(({isIntersecting, intersectionRatio, intersectionRect, target}) => ({
                    visible: isIntersecting,
                    ratio: intersectionRatio,
                    rect: intersectionRect,
                    id: target.id
                }))
        
                setViewportIntersections(intersections)
            }
        
            observer = new windowObject.IntersectionObserver(handler, options)
            privateObserver.set(windowObject, observer)
        }

        previous.forEach(({ref}) => {
            const unobserve = cleanup.get(ref)
            if (unobserve) {
                cleanup.delete(ref)
                unobserve()
            }
        })

        next.forEach(({id, ref}) => {
            const element = _.get(ref, ['refs', ''], windowObject.document.getElementById(id))
            cleanup.set(ref, () => observer.unobserve(element))
            observer.observe(element)
        })
    }),

    setViewportState: withActions(({setViewportState}, entry) => setViewportState(entry.id, entry)),
    invokeHandler: (handler, entry, compId) => handler && handler(entry, compId)
}
